export const parseBooleanFilterValue = (value: unknown): boolean | null => {
  if (value == null) return null;

  const rawValue = Array.isArray(value) ? value[0] : value;

  if (rawValue == null || rawValue === '') return null;

  return String(rawValue) === 'true';
};
